import React from 'react';
import './Plan.css'; // Import your CSS file

import { Button } from '../../components';

import { FaCheck } from 'react-icons/fa';


const Plan = ({ plan }) => {

  const { icon, image, title, price, note, features } = plan; // Extracting data from plan

  return (
    <div className="plan-item">

      <img src={image} alt={title} />

      <div className='top-icon'>{icon}</div> {/* Dynamic Icon */}

      <div className='content'>

        <h3>{title}</h3> {/* Plan Title */}
        <span></span> {/* Decorative Line */}
        <div className="price">${price} </div> {/* Plan Price */}
        <p>{note}</p> {/* Plan Details */}

        <Button link={"Book-Table"} title={"Book Now"} />

        {/* List of Features */}
        <ul>
          {features.map((feature, index) => (
            <li key={index}><div className='icon'><FaCheck /></div> {feature}</li> 
          ))}
        </ul>

      </div>

    </div>
  );
};

export default Plan;